import right from './right.svg';
import rightWhite from './rightWhite.svg';
import { isTalkie } from '../../utils';
export { default as inpaintIcon } from './inpaint.svg';
export { default as recreateIcon } from './recreate.svg';
export { default as backIcon } from './back.svg';
export { default as brusherIcon } from './brusher.svg';
export { default as eraserIcon } from './eraser.svg';
export { default as clearSelectionIcon } from './clear.svg';
export { default as undoIcon } from './undo.svg';
export { default as redoIcon } from './redo.svg';
export { default as minusIcon } from './minus.svg';
export { default as plusIcon } from './plus.svg';
export { default as copyIcon } from './copy.svg';
export { default as copiedIcon } from './copied.svg';
export { default as lassoIcon } from './lasso.svg';

export const rightIcon = isTalkie ? right : rightWhite;
